"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Witnesses = void 0;
var lodash_1 = require("lodash");
var Serialization_1 = require("../../Handlers/Serialization");
var WitnessFactory_1 = require("../Types/Witness/WitnessFactory");
var Witnesses = /** @class */ (function () {
    function Witnesses(witnesses) {
        if (lodash_1.isUndefined(witnesses)) {
            this.witnesses = [];
        }
        else {
            this.witnesses = witnesses;
        }
    }
    Witnesses.read = function (buffer, offset, full) {
        var witnesses = [];
        if (full) {
            var _a = Serialization_1.readVarInt(buffer, offset), witnessesLength = _a.value, tempOffset = _a.offset;
            offset = tempOffset;
            for (var i = 0; i < witnessesLength; i++) {
                var _b = WitnessFactory_1.WitnessFactory.read(buffer, offset), witness = _b.witness, witnessOffset = _b.offset;
                witnesses.push(witness);
                offset = witnessOffset;
            }
        }
        return { witnesses: new Witnesses(witnesses), offset: offset };
    };
    Witnesses.prototype.getSize = function (full) {
        return full ?
            Serialization_1.getSizeOfVarInt(this.witnesses.length) +
                lodash_1.sumBy(this.witnesses, function (witness) { return witness.getSize(); })
            :
                0;
    };
    Witnesses.prototype.write = function (buffer, offset, full) {
        if (full) {
            offset = Serialization_1.writeVarInt(this.witnesses.length, buffer, offset);
            this.witnesses.forEach(function (witness) { return offset = witness.write(buffer, offset); });
        }
        return offset;
    };
    Witnesses.prototype.toJson = function () {
        return {
            witnesses: this.witnesses.map(function (witness) { return witness.toJson(); }),
        };
    };
    return Witnesses;
}());
exports.Witnesses = Witnesses;
//# sourceMappingURL=Witnesses.js.map